(function () {
  'use strict';
  var dialog = document.querySelector('[data-non-somm-dialog]');
  if (!dialog) return;
  var panel = dialog.querySelector('[role="dialog"]');
  var form = dialog.querySelector('[data-non-somm]');
  var input = dialog.querySelector('[data-non-somm-input]');
  var openerText = dialog.querySelector('.non-somm-sheet__opener');
  var titleText = dialog.querySelector('#non-somm-title');
  var seedButtons = dialog.querySelectorAll('[data-somm-seed]');
  var defaultPlaceholder = input ? input.getAttribute('placeholder') : '';
  var defaultOpener = openerText ? openerText.textContent : '';
  var defaultTitle = titleText ? titleText.textContent : '';
  var defaultSeeds = Array.prototype.map.call(seedButtons, function (button) { return button.textContent; });
  var previousFocus;
  var previousOverflow = '';

  function closeMarketSelector() {
    var selector = document.querySelector('.non-market-store-popup');
    if (!selector) return;
    var closeButton = selector.querySelector('.non-market-store-popup__close');
    if (closeButton) closeButton.click();
    else selector.remove();
  }

  window.NON = window.NON || {};
  if (!window.NON.cart) {
    window.NON.cart = { add: function (variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Could not add that bottle.'); });
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (cartResponse) { return cartResponse.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('non:cart:added', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('theme:update:cart'));
          return cart;
        });
      });
    } };
  }

  function open(initialQuestion, opener) {
    /* Only one modal can own focus at a time. A geo-mismatch prompt may
       arrive just before the customer opens the Somm and otherwise sits
       above it, making the launcher and composer appear frozen. */
    closeMarketSelector();
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    if (opener && form.__nonSommSetContext) {
      var context = opener.getAttribute('data-somm-context') || 'home';
      var code = opener.getAttribute('data-somm-code') || '';
      form.__nonSommSetContext({
        context: context,
        code: code,
        product: opener.getAttribute('data-somm-product') || '',
        variant: opener.getAttribute('data-somm-variant') || '',
        title: opener.getAttribute('data-somm-product-title') || '',
        price: opener.getAttribute('data-somm-product-price') || '',
        available: opener.getAttribute('data-somm-product-available') || ''
      });
      if (input) input.setAttribute('placeholder', code ? 'Ask about ' + code : defaultPlaceholder);
      if (openerText) openerText.textContent = code ? 'Ask about ' + code + ', what is on the table, or what the night needs.' : (context === 'pairing' ? 'Name the dish or the occasion. The same Somm will carry the conversation from here.' : defaultOpener);
      if (titleText) titleText.textContent = code ? 'Ask about ' + code : defaultTitle;
      Array.prototype.forEach.call(seedButtons, function (button, index) {
        if (!code) { button.textContent = defaultSeeds[index]; return; }
        var prompts = [
          'What does ' + code + ' taste like?',
          'What food suits ' + code + '?',
          'How should I serve ' + code + '?',
          'Show me another bottle'
        ];
        button.textContent = prompts[index] || defaultSeeds[index];
      });
    }
    dialog.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.dispatchEvent(new CustomEvent('non:somm:opened'));
    requestAnimationFrame(function () {
      dialog.classList.add('is-open');
      input.focus();
      if (initialQuestion) {
        input.value = initialQuestion;
        if (form.__nonSommAsk) form.__nonSommAsk(initialQuestion);
      }
    });
  }
  function close() {
    dialog.classList.remove('is-open');
    document.documentElement.style.overflow = previousOverflow;
    document.dispatchEvent(new CustomEvent('non:somm:closed'));
    window.setTimeout(function () {
      dialog.hidden = true;
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }, 220);
  }

  window.NON.somm = {
    open: open,
    close: close,
    isOpen: function () { return !dialog.hidden; }
  };

  /* THE KEYBOARD, on a phone. The sheet is bottom-fixed, and iOS slides the
     keyboard over bottom-fixed elements without resizing the layout viewport
     — the input the customer just tapped disappears behind it. The visual
     viewport is the only honest measure of what a keyboard occludes, so the
     panel rides on it: lifted by the occluded height while the sheet is
     open, put back when it closes. */
  function liftAboveKeyboard() {
    if (!panel) return;
    if (dialog.hidden || !window.visualViewport || window.innerWidth > 767) {
      panel.style.bottom = '';
      return;
    }
    var vv = window.visualViewport;
    var occluded = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    panel.style.bottom = occluded ? occluded + 'px' : '';
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', liftAboveKeyboard);
    window.visualViewport.addEventListener('scroll', liftAboveKeyboard);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(liftAboveKeyboard).observe(dialog, { attributes: true, attributeFilter: ['hidden', 'class'] });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-non-somm-open]');
    if (opener) { event.preventDefault(); open(opener.getAttribute('data-question') || opener.getAttribute('data-somm-prompt') || '', opener); return; }
    if (event.target.closest('[data-non-somm-close]')) close();
  });
  document.querySelectorAll('[data-non-somm-inline]').forEach(function (inlineForm) {
    inlineForm.addEventListener('submit', function (event) {
      /* A full inline Somm owns its own submit through non-somm.js — the
         sheet is only for launcher forms with no controller of their own. */
      if (inlineForm.__nonSommAsk) return;
      event.preventDefault();
      var inlineInput = inlineForm.querySelector('[data-non-somm-input]');
      var query = inlineInput ? inlineInput.value.trim() : '';
      var prefix = inlineForm.getAttribute('data-somm-query-prefix') || '';
      if (inlineInput) inlineInput.value = '';
      open(prefix + query, inlineForm);
    });
  });
  document.addEventListener('click', function (event) {
    var seed = event.target.closest('[data-non-somm-launcher] [data-non-somm-seed]');
    if (!seed) return;
    /* A full inline Somm owns its chips through non-somm.js. The pairing
       launcher deliberately uses the lighter hand-off form instead: its
       submit opens this sheet and it has no __nonSommAsk controller of its
       own. Treat those chips exactly like submitting their label, otherwise
       they look interactive but do nothing. */
    var inline = seed.closest('[data-non-somm-inline]');
    if (inline && inline.__nonSommAsk) return;
    /* Seeds that live beside an inline Somm (the pairing page's examples)
       belong to that controller: route the question into the page, not the
       sheet. */
    var seedRoot = seed.closest('[data-non-somm-root]');
    var ownedForm = seedRoot && seedRoot.querySelector('[data-non-somm]');
    if (ownedForm && ownedForm.__nonSommAsk) {
      event.preventDefault();
      ownedForm.__nonSommAsk(seed.textContent.trim());
      return;
    }
    event.preventDefault();
    var launcher = inline || seed.closest('[data-non-somm-launcher]');
    open(seed.textContent.trim(), launcher);
  });
  document.addEventListener('keydown', function (event) {
    if (dialog.hidden) return;
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab') return;
    var focusable = panel.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();
